import * as actions from '../constants/action-types';
import axios from 'axios';
import { setLocalStorageItem } from '../utils/safe-storage';

export const setLocale = (locale) => {
    setLocalStorageItem('locale', locale);
    axios.defaults.headers.common['Accept-Language'] = locale;

    return {
        type: actions.SET_LOCALE,
        payload: {
            locale,
        },
    };
};
